import { defineMessages } from 'react-intl'

const scope = `procurify.hooks.useFormatDeclinedTransactionReason`

export default defineMessages({
  reasonInsufficientFunds: {
    id: `${scope}.reasonInsufficientFunds`,
    defaultMessage: 'Insufficient funds',
  },
  reasonUnsupportedCurrency: {
    id: `${scope}.reasonUnsupportedCurrency`,
    defaultMessage: 'Unsupported currency',
  },
  reasonForeignVendor: {
    id: `${scope}.reasonForeignVendor`,
    defaultMessage: 'Unsupported region',
  },
  reasonLockedCard: {
    id: `${scope}.reasonLockedCard`,
    defaultMessage: 'Locked card',
  },
  reasonCanceledCard: {
    id: `${scope}.reasonCanceledCard`,
    defaultMessage: 'Canceled card',
  },
  reasonVerificationFailed: {
    id: `${scope}.reasonVerificationFailed`,
    defaultMessage: 'Incorrect details',
  },
  reasonSuspectedFraud: {
    id: `${scope}.reasonSuspectedFraud`,
    defaultMessage: 'Suspected fraud',
  },
  reasonAccountInvalid: {
    id: `${scope}.reasonAccountInvalid`,
    defaultMessage: 'Inactive financial account',
  },
  reasonCardLostStolen: {
    id: `${scope}.reasonCardLostStolen`,
    defaultMessage: 'Card reported lost or stolen',
  },
  reasonCardNotActivated: {
    id: `${scope}.reasonCardNotActivated`,
    defaultMessage: 'Inactive card',
  },
  reasonRestrictedCountry: {
    id: `${scope}.reasonRestrictedCountry`,
    defaultMessage: 'Restricted country',
  },
  reasonCurrencyNotAllowed: {
    id: `${scope}.reasonCurrencyNotAllowed`,
    defaultMessage: 'Restricted currency',
  },
  reasonNotSupported: {
    id: `${scope}.reasonNotSupported`,
    defaultMessage: 'Transaction type not supported',
  },
  reasonTransactionBlockedAtTerminal: {
    id: `${scope}.reasonTransactionBlockedAtTerminal`,
    defaultMessage: 'Blocked by merchant',
  },
  reasonTransactionBlocked: {
    id: `${scope}.reasonTransactionBlocked`,
    defaultMessage: 'Could not be processed',
  },
  reasonUnknown: {
    id: `${scope}.reasonUnknown`,
    defaultMessage: 'Unknown error',
  },
})
